import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-learnosity-player',
    imports: [NgClass],
    templateUrl: './learnosity-player.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LearnosityPlayerComponent {
  @Input({ required: true }) public playerClass: string = '';
}
